module.exports = __webpack_public_path__ + "img/hb-bottom.fd83cd9b.png";